import React from 'react'

export default function Footer() {
    return (
        <footer>
            <div className="footer-block">
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-12 pt-2 mx-auto text-center bg-theme text-dark">

                        <h6>SVAYUKTYA_THEORGANICS copyright  &copy; 2020 Website Developed & Maintained by: Hitanshu Soni</h6>

                        </div>
                    
                    </div>
                </div>
            </div>
        </footer>
    )
}
